import React, { useState, useEffect, useLayoutEffect } from 'react';
import useMedia from 'use-media';
import { useHistory } from "react-router-dom";
import { useRtoaster } from '../../../hooks/useRtoaster';
import { connect, useStore } from 'react-redux';
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import { Button } from '../../atoms/button';
import { LabelInputForm } from "../../molecules/labelInputForm";
import './../../../resources_membership_hotel/css/hotel/membership_crawl.css';
import './../../../resources_membership_hotel/css/hotel/accompany.css';
import './../../../resources_membership_hotel/css/common/privilege_icon.css';
import { CrawlLogin, versionGetApi } from '../../../const';
import common from "../../../resources/js/common/common";
import CommonValidation from '../../../common/commonValidation';

const MembershipCrawlContainer = (props) => {
    const {
        crawlMember,
        setCrawlMember,
        setCrawlOpenInfo,
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const store = useStore();
    const history = useHistory();

    //表示ステート
    const [errorMessageId, setErrorMessageId] = useState("");
    const [errorMessagePass, setErrorMessagePass] = useState("");
    const [backgroundColorErrors, setBackgroundColorErrors] = useState({ id: false, pass: false });

    // rtoasterタグ生成
    useRtoaster();

    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    useEffect(() => {
        //バージョンの格納
        common.doPost(versionGetApi, {}, versionCheck);
        // 会員制の日付跨ぎチェック用フラグの初期化
        store.dispatch({ type: "OVERNIGHT_FLG", payload: { overnightFlg: false } });
        store.dispatch({ type: "MEMBERSHIP_RESV_START_DATE", payload: { membershipResvStartDate: "" } })
    }, []);

    const versionCheck = (res) => {
        if (res.data.version) {
            store.dispatch({ type: "VERSION", payload: { version: res.data.version } });
        }
    }

    /**
     * CRAWLログイン押下処理
     */
    const onClickCrawlLogin = (e) => {
        // Enterキー時用
        e.preventDefault();
        initErrorMessage();
        let err = false;
        const id = document.getElementById('crawlId').value;
        const password = document.getElementById('crawlPass').value;
        if (CommonValidation.Require(id)) {
            err = true;
            setErrorMessageId('ログインIDを入力してください');
            setBackgroundColorErrors((prev) => ({ ...prev, id: true }));
        }
        if (CommonValidation.Require(password)) {
            err = true;
            setErrorMessagePass('パスワードを入力してください');
            setBackgroundColorErrors((prev) => ({ ...prev, pass: true }));
        }
        if (!err) {
            common.doPost(
                CrawlLogin,
                { loginKey: id, password: password },
                afterCrawlLogin,
                errorCrawlLogin);
        }
    }

    /**
     * CRAWLログインリクエスト後処理
     * @param {any} res APIレスポンス
     */
    const afterCrawlLogin = (res) => {
        const data = res.data;
        if (data.resultCode === 'SUCCESS') {
            // ログイン情報の取得
            const apiKey = data.apiKey;
            const userNumber = data.userNumber;
            const loginUserInfo = data.loginUserInfo;
            const memberInfo = data.memberInfo;
            const memberCode = data.crawlUserInfo.syain_no;
            const hashAutoLogin = data.hashAutoLogin;
            // const resvKaiinken = data.resvKaiinken;
            const loginKey = data.loginKey;
            const loginType = data.loginType;
            store.dispatch(
                {
                    type: "LOGIN",
                    payload: {
                        apiKey: apiKey,
                        userNumber: userNumber,
                        loginUserInfo: loginUserInfo,
                        memberCode: memberCode,
                        hashAutoLogin: hashAutoLogin,
                        memberInfo: memberInfo,
                        userId: loginKey,
                        loginType: loginType
                    }
                }
            );
            setCrawlMember(data.crawlUserInfo);
            setCrawlOpenInfo({ open: data.open, close: data.close });
            history.push('/reserve/hotel/crawlSearch');
        } else {
            errorCrawlLogin();
        }
    }

    /**
     * CRAWLログインリクエストエラー処理
     */
    const errorCrawlLogin = () => {
        setErrorMessageId('ログインIDまたはパスワードに誤りがあります');
        setBackgroundColorErrors((prev) => ({ ...prev, id: true, pass: true }));
    }

    /**
     * CRAWLログインエラー情報初期化
     */
    const initErrorMessage = () => {
        setErrorMessageId('');
        setErrorMessagePass('');
        setBackgroundColorErrors({ id: false, pass: false });
    }

    return (
        <div style={isWideTablet ? styles.topCancel : styles.top}>
            <div className="membership_crawl_wrap">
                {errorMessageId !== "" ?
                    <div className='membership_crawl_error'>{errorMessageId}</div>
                    :
                    null
                }
                {errorMessagePass !== "" ?
                    <div className='membership_crawl_error'>{errorMessagePass}</div>
                    :
                    null
                }
                <form>
                    <div className="membership_crawl_wrap_innner">
                        <div className="membership_crawl">
                            <LabelInputForm
                                label="ログインID"
                                placeholder="ログインIDを入力"
                                labelClassName="membership_crawl_input_label"
                                className={backgroundColorErrors.id ? "membership_crawl_input_text_error" : "membership_crawl_input_text"}
                                id={"crawlId"}
                                maxLength={"256"}
                            />
                            <LabelInputForm
                                label="パスワード"
                                type="password"
                                placeholder="パスワードを入力"
                                labelClassName="membership_crawl_input_label"
                                className={backgroundColorErrors.pass ? "membership_crawl_input_text_error" : "membership_crawl_input_text"}
                                id={"crawlPass"}
                                maxLength={"14"}
                            />
                            <div className="membership_crawl_login_button_wrap">
                                <Button
                                    buttonText="ログイン"
                                    className="membership_crawl_login_button"
                                    onClick={onClickCrawlLogin} />
                            </div>
                            <p className="membership_crawl_login_attention">
                                ※IDとパスワードはTOKIOSと同じになります。
                                <br />パスワードを忘れた場合はTOKIOSにて初期化してください
                            </p>
                        </div>
                        <div className="membership_crawl"></div>
                    </div>
                </form>
            </div>
            <div className={isWideTablet ? "membership_reserve_cancel_footer2" : "membership_reserve_cancel_footer"} >
                <MembershipFooterContainer footerClass={"reservationResultFooterBase grayFooter"} />
            </div>
        </div >
    )
}

const styles = {
    top: {
        width: "100%",
        height: "calc(100vh - 154px)",
        paddingBottom: "50px",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
    topCancel: {
        width: "100%",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "gray",
        fontSize: "small",
    },
    breadCrumb: {
        display: "flex",
        color: "gray",
        paddingTop: "15px",
        width: "70%",
        marginRight: "auto",
        marginLeft: "auto",
        paddingBottom: "40px"
    },
}
const mapStateToProps = (state) => {
    return {
        crawlMember: state.crawlMember,
    };
};

const mapDisptchToProps = (dispatch) => {
    return {
        setCrawlMember: (item) => {
            dispatch({ type: "CRAWL_MEMBER", payload: { crawlMember: item } })
        },
        setCrawlOpenInfo: (item) => {
            dispatch({ type: "CRAWL_OPEN_INFO", payload: { crawlOpenInfo: item } })
        }
    };
};

export default connect(mapStateToProps, mapDisptchToProps)(MembershipCrawlContainer);
